type ContactFloatProps = {
  linkHref?: string;
  qrImgSrc?: string;
};

export default function ContactFloat({
}: ContactFloatProps) {
  return null;
}
